import { render, staticRenderFns } from "./NovaTarifaDialog.vue?vue&type=template&id=5f1841d4&"
import script from "./NovaTarifaDialog.vue?vue&type=script&lang=js&"
export * from "./NovaTarifaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports